// @react/hooks/useFiscalizationFiscalPoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationFiscalPointStore } from '@core/stores';

/**
 * React hook for FiscalPoint operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalizationFiscalPoint } from '@react/hooks';
 *
 * const FiscalPointList = observer(() => {
 *   const store = useFiscalizationFiscalPoint();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalizationFiscalPoint() {
  return fiscalizationFiscalPointStore;
}
